import { Component, Input } from '@angular/core';

export type IconName =
  | 'dashboard'
  | 'users'
  | 'car'
  | 'map'
  | 'route'
  | 'wallet'
  | 'receipt'
  | 'chart'
  | 'settings'
  | 'shield'
  | 'book'
  | 'logout'
  | 'menu'
  | 'search'
  | 'bell'
  | 'warning'
  | 'chevron'
  | 'moon'
  | 'x'
  | 'filter'
  | 'plus'
  | 'calendar'
  | 'taxi'
  | 'eye'
  | 'key'
  | 'unlock'
  | 'pdf'
  | 'excel';

@Component({
  selector: 'app-icon',
  standalone: true,
  templateUrl: './ui-icon.component.html',
  styleUrl: './ui-icon.component.scss'
})
export class UiIconComponent {
  @Input() name: IconName = 'dashboard';
  @Input() className = 'h-5 w-5';

  readonly paths: Record<IconName, string[]> = {
    dashboard: ['M4 13h7V4H4v9Z', 'M13 20h7V4h-7v16Z', 'M4 20h7v-5H4v5Z'],
    users: ['M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2', 'M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z', 'M22 21v-2a4 4 0 0 0-3-3.87', 'M16 3.13a4 4 0 0 1 0 7.75'],
    car: ['M5 17h14l-1.5-7.5A3 3 0 0 0 14.6 7H9.4a3 3 0 0 0-2.9 2.5L5 17Z', 'M7 17v2', 'M17 17v2', 'M8 13h8', 'M6 10H4', 'M20 10h-2'],
    map: ['M9 18 3 21V6l6-3 6 3 6-3v15l-6 3-6-3Z', 'M9 3v15', 'M15 6v15'],
    route: ['M6 19a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z', 'M18 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z', 'M9 16h4a5 5 0 0 0 5-5', 'M15 8H9a3 3 0 0 0-3 3v2'],
    wallet: ['M3 7h18v13H3V7Z', 'M16 12h5v4h-5a2 2 0 1 1 0-4Z', 'M3 7V5a2 2 0 0 1 2-2h12v4'],
    receipt: ['M6 2h12v20l-3-2-3 2-3-2-3 2V2Z', 'M9 7h6', 'M9 11h6', 'M9 15h4'],
    chart: ['M4 19V5', 'M4 19h16', 'M8 16v-5', 'M12 16V8', 'M16 16v-9'],
    settings: ['M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z', 'M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06A1.65 1.65 0 0 0 15 19.4a1.65 1.65 0 0 0-1 .6 1.65 1.65 0 0 0-.38 1.06V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 8.6 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.6 15a1.65 1.65 0 0 0-.6-1 1.65 1.65 0 0 0-1.06-.38H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 8.6a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.6c.4 0 .78-.14 1.06-.38A1.65 1.65 0 0 0 10.44 3V3a2 2 0 1 1 4 0v.09c0 .4.14.78.38 1.06.28.24.66.38 1.06.38a1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9c0 .4.14.78.38 1.06.24.28.62.38 1.06.38H21a2 2 0 1 1 0 4h-.09c-.4 0-.78.14-1.06.38-.24.28-.38.66-.38 1.06Z'],
    shield: ['M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z', 'M9 12l2 2 4-5'],
    book: ['M4 19.5A2.5 2.5 0 0 1 6.5 17H20', 'M4 4.5A2.5 2.5 0 0 1 6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15Z'],
    logout: ['M10 17l5-5-5-5', 'M15 12H3', 'M21 19V5a2 2 0 0 0-2-2h-4'],
    menu: ['M4 6h16', 'M4 12h16', 'M4 18h16'],
    search: ['M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z', 'M21 21l-4.35-4.35'],
    bell: ['M18 8a6 6 0 0 0-12 0c0 7-3 8-3 8h18s-3-1-3-8', 'M13.73 21a2 2 0 0 1-3.46 0'],
    warning: ['M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.36a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z', 'M12 9v4', 'M12 17h.01'],
    chevron: ['M9 18l6-6-6-6'],
    moon: ['M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79Z'],
    x: ['M18 6 6 18', 'M6 6l12 12'],
    filter: ['M4 5h16', 'M7 12h10', 'M10 19h4'],
    plus: ['M12 5v14', 'M5 12h14'],
    calendar: ['M8 2v4', 'M16 2v4', 'M3 10h18', 'M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z'],
    taxi: ['M5 17h14l-1.5-7.5A3 3 0 0 0 14.6 7H9.4a3 3 0 0 0-2.9 2.5L5 17Z', 'M7 17v2', 'M17 17v2', 'M8 13h8', 'M9 7l1-3h4l1 3'],
    eye: [
      'M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z',
      'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z'
    ],
    key: [
      'M7.5 15.5a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Z',
      'M11 12h10',
      'M18 12v3',
      'M21 12v3'
    ],
    unlock: [
      'M7 11V8a5 5 0 0 1 9.9-1',
      'M5 11h14v10H5V11Z',
      'M12 16v2'
    ],
    pdf: [
      'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6Z',
      'M14 2v6h6',
      'M9.5 16.5v-5H11a1.5 1.5 0 0 1 0 3h-1.5',
      'M14 11.5v5h1.2a1.8 1.8 0 0 0 0-3.6H14'
    ],
    excel: [
      'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6Z',
      'M14 2v6h6',
      'M9 12.5l2.2 3.5',
      'M11.2 12.5 9 16',
      'M14.2 12.5h2.5',
      'M15.45 12.5V16'
    ]
  };
}
